/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoGallery_user = {
    readonly serviceId: string | null;
    readonly " $refType": "SbRespInteriorsPhotoGallery_user";
};
export type SbRespInteriorsPhotoGallery_user$data = SbRespInteriorsPhotoGallery_user;
export type SbRespInteriorsPhotoGallery_user$key = {
    readonly " $data"?: SbRespInteriorsPhotoGallery_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoGallery_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoGallery_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'f25edf5adbdc52334eab8302f9a03b96';
export default node;
